<template>
  <div class="home-activity-body">
    <div class="home-activity-head">
      <strong>最新活动 一手掌握</strong>
      <a-input-search
        style="width: 640px"
        size="large"
        placeholder="请输入关键词搜索"
        enter-button
        v-model="searchVal"
        @search="onSearch"
      />
    </div>
    <div class="home-activity-content-body">
      <div class="home-activity-search-num">
        关于「{{ searchTitleVal }}」的搜索结果，共 {{ activityList.length }} 条
      </div>
      <div class="home-activity-list">
        <div
          v-for="el in activityList"
          :key="el.id"
          @click="activityDetail(el.id)"
        >
          <span>
            <i>
              <v-activity-status :activity-status="el.activityStatus" />
            </i>
            <v-img
              :attachment-id="el.coverId"
              :default-img="require('@/assets/img/mediaApp2.png')"
            ></v-img>
          </span>
          <div>
            <strong>{{ el.activityName }}</strong>
            <p>
              <span
                >报名时间：{{ el.enrollStartTime }} 至
                {{ el.enrollEndTime }}</span
              >
              <span
                >活动时间：{{
                  el.activityTime | moment("YYYY-MM-DD HH时")
                }}</span
              >
            </p>
            <div>
              <span>活动地点：{{ el.activityPlace }}</span>
              <p>
                <span
                  ><a-icon type="user-add" />{{
                    el.enrollNumber ? el.enrollNumber : "0"
                  }}人报名</span
                >
                <span
                  ><a-icon type="message" />{{
                    el.reviewNumber ? el.reviewNumber : "0"
                  }}讨论</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList } from "@/api/activity";
import VImg from "@/components/VImg";
import VActivityStatus from "@/components/VActivityStatus";
export default {
  components: { VActivityStatus, VImg },
  data() {
    return {
      searchVal: "",
      activityList: [],
    };
  },
  mounted() {
    this.searchVal = this.$route.query.search;
    this.searchTitleVal = this.$route.query.search;
    this.loadgetActivityList();
  },
  methods: {
    loadgetActivityList() {
      if (!this.searchVal) {
        this.$message.warning("请输入搜索关键词");
        return;
      }
      let data = {
        activityName: this.searchVal,
        activityType: "",
        activityPlace: "",
        activityStatus: "",
      };
      let page = {
        size: 10,
        current: 1,
      };
      getActivityList(page, data).then((res) => {
        this.activityList = res.data.records;
      });
    },
    activityDetail(id) {
      this.$router.push({
        path: "/homeActivity/detail",
        query: { id: id },
      });
    },
    onSearch() {
      if (!this.searchVal) {
        this.$message.warning("请输入搜索关键词");
        return;
      }
      this.searchTitleVal = this.searchVal;
      this.loadgetActivityList();
    },
  },
};
</script>

<style lang="less" scoped>
.home-activity-head {
  height: 280px;
  background: url(../../assets/img/hdbanner.jpg) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 80px;
  > strong {
    font-size: 44px;
    display: block;
    line-height: 44px;
    color: #fff;
    margin-bottom: 50px;
  }
}
.home-activity-content-body {
  width: 1200px;
  margin: 0 auto 0;
  padding-bottom: 60px;
  .home-activity-search-num {
    margin-bottom: 24px;
    color: #8c8c8c;
    line-height: 14px;
    margin-top: 24px;
  }
  .home-activity-list {
    padding: 0 24px;
    background: #fff;
    > div {
      padding: 24px 0;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      cursor: pointer;
      > span {
        position: relative;
        width: 210px;
        height: 120px;
        margin-right: 24px;
        > img {
          width: 100%;
          height: 100%;
        }
        > i {
          position: absolute;
          top: 0;
          left: 8px;
          z-index: 2;
        }
      }
      > div {
        flex: 1;
        > strong {
          font-size: 20px;
          display: block;
          line-height: 20px;
          margin-bottom: 40px;
        }
        > p {
          display: flex;
          color: #8c8c8c;
          margin-bottom: 16px;
          > span {
            line-height: 14px;
            margin-right: 40px;
          }
        }
        > div {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #8c8c8c;
          > span {
            line-height: 14px;
          }
          > p {
            display: flex;
            > span {
              line-height: 14px;
              margin-left: 16px;
              display: flex;
              align-items: center;
              > i {
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }
}
.home-dynamic-page {
  padding: 24px;
  text-align: right;
}
</style>
<style>
.before-content-body {
  background: #f7f7f7;
}
.ant-btn-primary {
  background-color: #1abc9c !important;
  border-color: #1abc9c !important;
}
.home-activity-head .ant-input {
  border-width: 3px;
  border-color: #1abc9c;
}
</style>
